import { Link } from "react-router-dom";
import { Badge } from "@/components/ui/Toast";
import { ActionButton, actionLinkClasses } from "@/components/ui/ActionButton";
import type { Usuario } from "@/api/usuarios";

interface UsuarioRowProps {
  usuario: Usuario;
  currentUserId: number | undefined;
  onDelete: (usuario: Usuario) => void;
}

export const UsuarioRow = ({
  usuario,
  currentUserId,
  onDelete,
}: UsuarioRowProps) => (
  <>
    <td className="px-4 py-3 font-medium text-ink-primary">
      {usuario.nombre}
    </td>
    <td className="px-4 py-3 text-ink-secondary">{usuario.email}</td>
    <td className="px-4 py-3">
      <ActionButton as="chip" color="blue">
        {usuario.rol_nombre ?? "—"}
      </ActionButton>
    </td>
    <td className="px-4 py-3">
      <Badge variant={usuario.activo ? "success" : "danger"}>
        {usuario.activo ? "Activo" : "Inactivo"}
      </Badge>
    </td>
    <td className="px-4 py-3">
      <div className="flex justify-end gap-2">
        <Link
          to={`/usuarios/${usuario.id}/editar`}
          className={actionLinkClasses("blue")}
          aria-label={`Editar ${usuario.nombre}`}
        >
          Editar
        </Link>
        <Link
          to={`/usuarios/${usuario.id}/permisos`}
          className={actionLinkClasses("amber")}
          aria-label={`Permisos de ${usuario.nombre}`}
        >
          Permisos
        </Link>
        <ActionButton
          color="red"
          disabled={currentUserId === usuario.id}
          onClick={() => onDelete(usuario)}
          aria-label={`Eliminar ${usuario.nombre}`}
        >
          Eliminar
        </ActionButton>
      </div>
    </td>
  </>
);